export default __webpack_public_path__ + "static/media/landing-agent-feature-4.bab13e4e.svg";